module.exports = __webpack_public_path__ + "img/receipt.37f7048f.svg";